<div *ngFor="let category of categories; trackBy: trackById"
     class="category"
     [class.selected]="category.id === value"
     [attr.title]="category.label"
     (click)="valueChange.emit(category.id); $event.preventDefault()">
  {{category.label}}
</div>
